import React, {FC} from 'react';
import messages from './messages';
import AsyncItemPicker from 'components/async-item-picker';
import SectionSeparator from 'components/separator/section-separator';
import TextInput from 'components/text-input';
import {useTranslation} from 'react-i18next';
import {Col, Row} from 'reactstrap';
import {Option} from 'types/option';
import {ValidationErrors} from 'services/api/types';

interface Props {
  params: any;
  validationErrors: ValidationErrors;
  onChangeParams: (p: any) => void;
  is_locked?: boolean;
}
const VatAndTaxes: FC<Props> = props => {
  const {t} = useTranslation();
  const {validationErrors, params, onChangeParams, is_locked} = props;

  return (
    <div>
      <SectionSeparator title={t(...messages.title())} />

      <Row>
        <Col md={12}>
          <TextInput
            label={t(...messages.invoiceVtaNumber())}
            data-testid="product-name-input"
            disabled={params.with_vat || is_locked}
            value={params.vat_number}
            errors={validationErrors.vat_number}
            onChange={vat_number => {
              onChangeParams({
                ...params,
                vat_number,
              });
            }}
          />
        </Col>
        <Col md={12} className="my-2">
          <AsyncItemPicker
            key={'with-vat-' + !!params.with_vat}
            endPoint="data/vat-modes"
            disabled={params.with_vat || is_locked}
            label={t(...messages.invoiceVtaMode())}
            getOptionLabel={(x: Option) => x.label}
            getOptionValue={(x: Option) => x.value}
            errors={validationErrors.vat_mode}
            value={params.vat_mode}
            onChange={vat_mode => onChangeParams({...params, vat_mode})}
          />
        </Col>
        <Col md={12} className="my-2">
          <div className="form-check ">
            <input
              className="form-check-input"
              type="checkbox"
              id="is-detaxed"
              disabled={is_locked}
              onChange={() =>
                onChangeParams({
                  ...params,
                  is_detaxed: !params.is_detaxed,
                  with_vat: false,
                })
              }
              checked={params.is_detaxed}
            />
            <label className="form-check-label" htmlFor="is-detaxed">
              {t(...messages.invoiceVatIncluded())}
            </label>
          </div>
          <div className="form-check my-2">
            <input
              className="form-check-input"
              type="checkbox"
              id="with-vat"
              disabled={is_locked}
              onChange={() =>
                onChangeParams({
                  ...params,
                  with_vat: !params.with_vat,
                  is_detaxed: false,
                })
              }
              checked={params.with_vat}
            />
            <label className="form-check-label" htmlFor="with-vat">
              {t(...messages.invoiceVatExcluded())}
            </label>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default VatAndTaxes;
